"use client";

import { Row, Col, Card } from "react-bootstrap";
import { useDashboardData } from "../../../../hooks/useDashboardData"; // adjust path

const ProjectsOverview = () => {
  const { summaryCounts } = useDashboardData(); // fetch the API data

  const formatCount = (value) => {
    return String(value ?? 0).padStart(2, "0");
  };

  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <div>
            <h3 className="mb-0">Team Overview</h3>
          </div>

          <Row>
            <Col xs={12} sm={6} xl={6}>
              <Card className="bg-primary bg-opacity-10 border-primary border-opacity-10 rounded-3 mt-4 stats-box style-three">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-10">
                    <div className="flex-shrink-0">
                      <span className="material-symbols-outlined fs-40 text-primary">
                        group
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <span>Total Members</span>
                      <h3 className="fs-20 mt-1 mb-0">
                        {formatCount(summaryCounts.totalMembers)}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} xl={6}>
              <Card className="bg-success bg-opacity-10 border-success border-opacity-10 rounded-3 mt-4 stats-box style-three">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-10">
                    <div className="flex-shrink-0">
                      <span className="material-symbols-outlined fs-40 text-success">
                        work
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <span>Working</span>
                      <h3 className="fs-20 mt-1 mb-0">
                        {formatCount(summaryCounts.working)}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} xl={6}>
              <Card className="bg-info bg-opacity-10 border-info border-opacity-10 rounded-3 mt-4 stats-box style-three">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-10">
                    <div className="flex-shrink-0">
                      <span className="material-symbols-outlined fs-40 text-info">
                        groups
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <span>In Meeting</span>
                      <h3 className="fs-20 mt-1 mb-0">
                        {formatCount(summaryCounts.meeting )}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} xl={6}>
              <Card className="bg-warning bg-opacity-10 border-warning border-opacity-10 rounded-3 mt-4 stats-box style-three">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-10">
                    <div className="flex-shrink-0">
                      <span className="material-symbols-outlined fs-40 text-warning">
                        Local_Cafe
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <span>On Break</span>
                      <h3 className="fs-20 mt-1 mb-0">
                        {formatCount(summaryCounts.break)}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} xl={6}>
              <Card className="bg-danger-div bg-opacity-10 border-danger-div border-opacity-10 rounded-3 mt-4 stats-box style-three">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center mb-0">
                    <div className="flex-shrink-0">
                      <span className="material-symbols-outlined fs-40 text-danger-div">
                        group
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-2">
                      <span>Offline</span>
                      <h3 className="fs-20 mt-1 mb-0">
                        {formatCount(summaryCounts.offline)}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default ProjectsOverview;
